import Segara1 from '../../../Media/KHI/Segara City/Segara City (1).webp'
import Segara2 from '../../../Media/KHI/Segara City/Segara City (2).webp'
import Segara3 from '../../../Media/KHI/Segara City/Segara City (3).webp'
import Segara4 from '../../../Media/KHI/Segara City/Segara City (4).webp'
import Segara5 from '../../../Media/KHI/Segara City/Segara City (5).webp'
import Segara6 from '../../../Media/KHI/Segara City/Segara City (6).webp'
import Segara7 from '../../../Media/KHI/Segara City/Segara City (7).webp'



const Segaraimages =[
Segara1,Segara2,Segara3,Segara4,Segara5,Segara6,Segara7
]

export default Segaraimages;